export default {
  'applications.title': 'Gestionar Solicitudes',
  'applications.detail.title': 'Detalles de solicitud {name}',
  'applications.bulkDetail.title': 'Detalles de Tarea Carga Masiva {name}',
  'applications.detail.application': 'Solicitud',
  'applications.detail.timeline.today': 'Hoy',
  'applications.detail.timeline.yesterday': 'Ayer',
  'applications.detail.timeline.autoGroup':
    '{count, plural, one {# paso automático completado} other {# pasos automáticos completados}}',
  'applications.detail.timeline.showSteps': 'Ver pasos',
  'applications.detail.timeline.hideSteps': 'Ocultar pasos',
  'applications.detail.info.more': 'Más información',
  'applications.detail.info.less': 'Menos información',
  'applications.detail.error.more': 'Ver detalle del error',
  'applications.detail.error.less': 'Ocultar detalle',
  'applications.detail.history.banner.title': 'Estás viendo un paso anterior del historial',
  'applications.detail.history.banner.subtitle':
    'La información mostrada corresponde a lo cargado hasta este paso.',
  'applications.detail.history.banner.back': 'Volver a la versión actual',
  'applications.detail.metrics.title': 'Pulso de la solicitud',
  'applications.detail.metrics.totalDuration': 'Tiempo total',
  'applications.detail.metrics.steps': 'Pasos ejecutados',
  'applications.detail.metrics.stepsBreakdown': '{auto} autom. · {manual} manuales',
  'applications.detail.metrics.inCurrentStep': 'En el paso actual',
  'applications.detail.metrics.avgPerStep': 'Promedio por paso',
  'applications.detail.metrics.automation': 'Automatización',
  'applications.detail.metrics.bottleneck': 'Paso más largo',
  'applications.detail.metrics.activity': 'Actividad por día',
  'applications.diagram.pulse.bottleneckHint': 'Paso más largo · clic para inspeccionarlo',
  'applications.diagram.pulse.rework': 'reejecuciones',
  'applications.diagram.pulse.errors': 'con error',
  'applications.diagram.inspector.close': 'Cerrar inspector',
  'applications.diagram.inspector.started': 'Inició',
  'applications.diagram.inspector.finished': 'Finalizó',
  'applications.diagram.inspector.duration': 'Duración',
  'applications.diagram.inspector.sinceStart': 'Desde el inicio de la solicitud',
  'applications.diagram.inspector.overdue': 'Fecha de vencimiento',
  'applications.diagram.inspector.executions':
    '{count, plural, one {# ejecución} other {# ejecuciones}}',
  'applications.diagram.inspector.bottleneckHint':
    'Este es el paso que más tiempo consumió en la solicitud.',
  'applications.diagram.inspector.overdueHint': 'Este paso superó su fecha de vencimiento.',
  'applications.diagram.inspector.notExecuted':
    'Este paso aún no se ha ejecutado en esta solicitud.',
  'applications.complete.title': 'Completar Información {name}',
  'applications.complete.titlePrefix': 'Completar Información',
  'applications.text.resendNotification': 'Reenviar Notificación',
  'applications.text.versionHistory': 'Historial de versiones',
  'applications.text.loadingText': 'Cargando información',
  'applications.text.actions': 'Acciones',
  'applications.text.variables': 'Variables',
  'applications.text.template': 'Plantilla',
  'applications.text.capacitation': 'Capacitaciones',
  'applications.text.attachment': 'Adjuntar boleta pago trabajador',
  'applications.history.title1': 'Historial',
  'applications.history.title': 'Selecciona el paso que deseas revisar',
  'applications.history.subTitle': 'Esta acción mostrará la documentación cargada hasta esa fecha:',
  'applications.history.current': 'Actual',
  'applications.history.return': 'Volver',
  'applications.history.previous': 'Anteriores',
  'applications.text.form': 'Formulario',
  'applications.text.forms': 'Formularios',
  'applications.text.comments': 'Comentarios',
  'applications.comments.empty.title': 'Comentarios',
  'applications.comments.empty.description':
    'Los comentarios son una función que lo ayuda a conversar con los usuarios dentro de una solicitud.',
  'applications.comments.empty.cta': 'Enviemos tu primer comentario',
  'applications.comments.empty.alt': 'Ilustración de comentarios',
  'applications.comments.mentions.empty': 'No se encontraron usuarios',
  'applications.comments.actions.edit': 'Editar comentario',
  'applications.comments.actions.save': 'Guardar',
  'applications.comments.actions.cancel': 'Cancelar',
  'applications.comments.actions.delete': 'Eliminar comentario',
  'applications.comments.actions.update': 'Editar',
  'applications.comments.actions.delete.confirm': '¿Eliminar este comentario?',
  'applications.comments.actions.delete.ok': 'Eliminar',
  'applications.comments.actions.delete.cancel': 'Cancelar',
  'applications.comments.actions.delete.description':
    'Este comentario se eliminará permanentemente.',
  'applications.comments.edit.validation': 'Escribe un comentario antes de guardar.',
  'applications.comments.edit.title': 'Editar comentario',
  'applications.comments.timestamp.edited': 'editado',
  'applications.comments.timestamp.editedBy': 'editado por {name}',
  'applications.text.notifyUsers': 'Notificar a Usuarios',
  'applications.text.writeComment': 'Escriba un Comentario',
  'applications.text.mailsTracking': 'Correos',
  'applications.text.engine': 'Ejecuciones',
  'applications.text.engine.action.reevaluate': 'Reevaluar',
  'applications.text.engine.action.reevaluate.confirmContent':
    '¿Desea reevaluar esta tarea del motor de proceso?',
  'applications.text.traces': 'Seguimiento',
  'applications.text.reassignedTasks': 'Reasignadas',
  'applications.text.reassigned.sourceUser': 'Usuario Origen',
  'applications.text.reassigned.destinationUser': 'Usuario Destino',
  'applications.text.reassigned.reason': 'Motivo',
  'applications.text.reassigned.detailTitle': 'Detalle de Tarea Reasignada',
  'applications.text.commandTraces': 'Acciones',
  'applications.text.command.commandType': 'Tipo',
  'applications.text.command.data': 'Datos',
  'applications.text.commandType.details': 'Detalles',
  'applications.text.commandType.approve': 'Aprobar',
  'applications.text.commandType.reject': 'Rechazar',
  'applications.text.commandType.complete': 'Completada',
  'applications.text.commandType.executeTask': 'Ejecutada',
  'applications.text.commandType.sign': 'Firmar',
  'applications.text.commandType.cancel': 'Cancelar Solicitud',
  'applications.text.commandType.void': 'Anular Solicitud',
  'applications.text.commandType.sendNotifications': 'Reenviar Notificaciones',
  'applications.text.commandType.evaluateApprovers': 'Evaluar Aprobadores',
  'applications.text.commandType.backToStep': 'Retroceder Solicitud',
  'applications.text.commandType.reassignTask': 'Reasignar Tarea',
  'applications.text.commandType.executeAutomaticAction': 'Ejecutar Acción Automática',
  'applications.text.commandType.history': 'Historial de Versiones',
  'applications.text.commandType.continue': 'Editar',
  'applications.text.commandType.autoAssignTask': 'Autoasignar Tarea',
  'applications.text.commandType.goToStep': 'Adelantar Solicitud',
  'applications.text.commandType.removeProcessInstance': 'Eliminar Solicitud',
  'applications.text.commandType.clearError': 'Reevaluar Error',
  'applications.text.commandType.startRequest': 'Iniciar Solicitud',
  'applications.text.commandType.goToActionFromCustomCommand':
    'Ir a Acción desde Comando Perzonalizado',
  'applications.text.commandType.aiInteract': 'Interactuar con IA',
  'applications.text.commandType.share': 'Compartir',
  'applications.text.commandType.autoCancel': 'Cancelación automática',
  'applications.text.commandType.autoVoid': 'Anulación automática',
  'applications.text.engine.id': 'ID',
  'applications.text.engine.importance': 'Importancia',
  'applications.text.engine.created': 'Creado',
  'applications.text.engine.importance.none': 'Ninguna',
  'applications.text.engine.importance.low': 'Baja',
  'applications.text.engine.importance.medium': 'Media',
  'applications.text.engine.importance.high': 'Alta',
  'applications.text.engine.importance.urgent': 'Urgente',
  'applications.text.engine.importance.critical': 'Crítica',
  'applications.text.engine.operationType.evaluateApprovers': 'Evaluar Aprobadores',
  'applications.text.engine.operationType.handleNotifications': 'Enviar Notificaciones',
  'applications.text.engine.operationType.handleAutomaticActions': 'Manejar Acción Automática',
  'applications.text.engine.operationType.handleOverdue': 'Manejar Vencimiento',
  'applications.text.engine.operationType.handleApprovalReminderNotifications':
    'Enviar Notificaciones Recordatorio Aprobación',
  'applications.text.engine.operationType.handleIteration': 'Manejar Acción Automática / Iteración',
  'applications.text.engine.operationType.handleEntityOperation':
    'Manejar Acción Automática / Operación Entidad Dinámica',
  'applications.text.engine.operationType.attachmentsCopy': 'Copiar Adjuntos',
  'applications.text.engine.operationType.handleFinishCompleteInformationCompleted':
    'Manejar Finalización de Acción de Completar Información Completada',
  'applications.text.engine.operationType.handleRunCode': 'Manejar Acción Automática / Run Code',
  'applications.text.engine.operationType.handleWaitChildRequestsReevaluate':
    'Manejar Acción Automática / Reevaluar Estado de Solicitudes Hijas',
  'applications.text.engine.operationType.reevaluateEmailTrackingEvents':
    'Reevaluar Seguimiento de Correo',
  'applications.text.engine.operationType.autoSuccessEmailTrackingAfterStabilization':
    'Marcar Seguimiento de Correo como Exitoso tras Estabilización',
  'applications.text.engine.operationType.unknown': 'Operación desconocida',
  'applications.loading.results': 'Cargando resultados',
  'applications.text.tabDocumentsTitle': 'Tus documentos ({count})',
  'applications.text.tabMailsTitle': 'Seguimiento de correos ({count})',
  'applications.text.tabTraceRecords': '{count} registros de seguimiento',
  'applications.text.errorTitle': 'Solicitud con Errores',
  'applications.text.securityCode': 'PIN',
  'applications.text.itemsAffected': 'Elementos Afectos',
  'applications.text.itemsCount': 'Cantidad de Elementos',
  'applications.text.insertItems': 'Elementos a Insertar',
  'applications.text.opsResultStatus': 'Estado Resultado de Operación',
  'applications.text.handlerType': 'Tipo de Controlador',
  'applications.text.model': 'Modelo',

  'applications.text.observations': 'Observaciones',
  'applications.text.chatMessageContent': 'Contenido del Mensaje',
  'applications.text.chatInternalTaskId': 'ID Tarea Interna de Chat',
  'applications.text.finishedDate': 'Fecha Finalizada',
  'applications.text.actionResults.description':
    'Consulta los {name} ejecutados en esta acción.',
  'applications.text.actionResults.order.desc': 'Descendente',
  'applications.text.actionResults.order.asc': 'Ascendente',
  'applications.text.executeApiCall.results': 'Resultados Llamada API',
  'applications.text.executeApiCall.result': 'Resultado Llamada API',
  'applications.text.integration.results': 'Resultado Llamada API',
  'applications.text.dynamicEntityOperation.results': 'Resultados Operación Entidad Dinámica',
  'applications.text.dynamicEntityOperation.result': 'Resultado Operación Entidad Dinámica',
  'applications.text.googleIntegration.connection': 'Conexión',
  'applications.text.whatsAppBusinessIntegration.connection': 'Conexión',
  'applications.text.consumeSequence.results': 'Resultado Operación Consumir Secuencia',
  'applications.text.executeRpaFlow.results': 'Resultados Llamada RPA',
  'applications.text.executeRpaFlow.result': 'Resultado Llamada RPA',
  'applications.text.internalOperation.results': 'Resultados Operación Interna',
  'applications.text.internalOperation.result': 'Resultado Operación Interna',
  'applications.text.internalOperation.success': 'Éxito',
  'applications.text.internalOperation.error': 'Error',
  'applications.text.internalOperation.operationStatus': 'Estado de Operación',
  'applications.text.internalOperation.type': 'Tipo de Operación',
  'applications.text.internalOperation.successDescription': 'Operación completada {status}',
  'applications.text.mappingFilters': 'Filtros de Mapeo',
  'applications.text.mappingTableFilters': 'Filtros de Tabla de Mapeo',
  'applications.text.updateValues': 'Valores de Actualización',
  'applications.text.affectedItems': 'Elementos Afectados',
  'applications.text.itemsAffected.one': 'Uno',
  'applications.text.itemsAffected.all': 'Todos',
  'applications.text.itemsAffected.custom': 'Personalizado',
  'applications.text.internalOperationType.search': 'Buscar',
  'applications.text.internalOperationType.add': 'Agregar',
  'applications.text.internalOperationType.modify': 'Modificar',
  'applications.text.internalOperationType.activate': 'Activar',
  'applications.text.internalOperationType.deactivate': 'Desactivar',
  'applications.text.internalOperationType.remove': 'Eliminar',
  'applications.text.internalOperationType.count': 'Contar',
  'applications.text.internalOperationType.canceldelegation': 'Anular Delegación',
  'applications.text.conditional.results': 'Resultado de Evaluación Condiciones',
  'applications.text.setVariable.results': 'Resultado Operación Establecer Variable',
  'applications.text.setVariableData.results': 'Resultado Operación Establecer Variable',
  'applications.text.setFormData.results': 'Resultado Operación Establecer Datos Formulario',
  'applications.text.iterate.table': 'Tabla a Iterar',
  'applications.text.iterate.form': 'Formulario a Iterar',
  'applications.text.iterate.entity': 'Entidad a Iterar',
  'applications.text.iterate.attachment': 'Campo Adjunto a Iterar',
  'applications.text.iterate.results': 'Resultados Iteración',
  'applications.text.switch.results': 'Resultado de Evaluación',
  'applications.text.internalOperation.results': 'Resultado Operación Interna',
  'applications.text.completeInformation.results': 'Resultado Operación Webhook',
  'applications.text.sendEmail.results': 'Resultados Enviar Correo',
  'applications.text.sendEmail.result': 'Resultado Enviar Correo',
  'applications.text.sendEmail.emailTrackingAwaitingHint':
    'Esperando confirmación del correo enviado. AUTOMY está monitoreando los eventos de entrega para continuar el flujo cuando se complete la validación o se alcance la fecha límite de espera.',
  'applications.text.emailTrackingResult.results': 'Resultado trazas correo',
  'applications.text.emailTrackingResult.result': 'Trazas de entrega de correo',
  'applications.text.emailTrackingResult.summary.validationMode': 'Modo de validación',
  'applications.text.emailTrackingResult.summary.waitDeadlineDateTime': 'Fecha límite de espera',
  'applications.text.emailTrackingResult.summary.deliveryStabilizationTimeUnit':
    'Unidad tiempo estabilización entrega',
  'applications.text.emailTrackingResult.summary.deliveryStabilizationTimeValue':
    'Valor tiempo estabilización entrega',
  'applications.text.emailTrackingResult.summary.deliveryStabilizationDeadlineDateTime':
    'Fecha límite estabilización entrega',
  'applications.text.emailTrackingResult.summary.deliveredDateTime': 'Fecha de entrega',
  'applications.text.emailTrackingResult.summary.lastEvent': 'Último evento',
  'applications.text.emailTrackingResult.summary.finalEvent': 'Evento final',
  'applications.text.mailTrackingValidationMode.delivery': 'Entrega',
  'applications.text.mailTrackingValidationMode.open': 'Apertura',
  'applications.text.mailTrackingValidationMode.click': 'Clic',
  'applications.text.openAi.results': 'Resultados Llamada Open AI',
  'applications.text.openAi.result': 'Resultado Llamada Open AI',
  'applications.text.automyAi.results': 'Resultados Automy IA',
  'applications.text.automyAI.result': 'Resultado Automy IA',
  'applications.text.automyAI.chatWithAgent': 'Interactuar',
  'applications.text.runCode.results': 'Resultados Operación',
  'applications.text.runCode.result': 'Resultado Operación',
  'applications.text.teams': 'Teams',
  'applications.text.sms': 'SMS',
  'applications.text.microsoftTeamsIntegration.results': 'Mensajes Teams',
  'applications.text.microsoftTeamsIntegration.result': 'Mensaje Teams',
  'applications.text.sendSms.results': 'Mensajes SMS',
  'applications.text.sendSms.result': 'Mensaje SMS',
  'applications.text.sms.connectionName': 'Conexión',
  'applications.text.sendMail.details': 'Detalles',
  'applications.text.sendMail.history': 'Historial de Eventos',
  'applications.text.overdueDateTime': 'Fecha y Hora de Vencimiento',

  'applications.text.runCode.status': 'Estado',
  'applications.text.runCode.status.pending': 'Pendiente',
  'applications.text.runCode.status.installing': 'Instalando',
  'applications.text.runCode.status.running': 'Ejecutando',
  'applications.text.runCode.status.completed': 'Completado',
  'applications.text.runCode.status.failed': 'Fallido',
  'applications.text.runCode.status.expired': 'Expirado',
  'applications.text.runCode.status.error': 'Error',
  'applications.text.runCode.status.notfound': 'No Encontrado',

  'applications.text.rpaInstanceSendStatus.pending': 'Pendiente',
  'applications.text.rpaInstanceSendStatus.sent': 'Enviado',
  'applications.text.rpaInstanceSendStatus.error': 'Error',
  'applications.text.rpaInstanceSendStatus.offlineAgent': 'Agente Desconectado',

  'applications.text.rpaInstanceResponseStatus.pending': 'Pendiente',
  'applications.text.rpaInstanceResponseStatus.success': 'Éxito',
  'applications.text.rpaInstanceResponseStatus.error': 'Error',
  'applications.text.responseTicket': 'Ticket de Respuesta',
  'applications.text.lastStatusCheckDate': 'Última Fecha de Verificación de Estado',
  'applications.text.finishedDateTime': 'Fecha y Hora de Finalización',
  'applications.text.iterateSteps': 'Pasos de Ejecución',

  'applications.text.sendMail.messageId': 'ID del Mensaje',
  'applications.text.sendMail.uniqueArgs': 'Arg. Únicos',
  'applications.text.sendMail.responseCode': 'Código de Respuesta',

  'applications.text.progress': 'Completado',
  'applications.text.moreActions': 'Otras Acciones',
  'applications.text.originIp': 'IP Origen',
  'applications.text.originDomain': 'Dominio de Origen',
  'applications.text.parameters': 'Parámetros',
  'applications.text.insertedData': 'Data Insertada',

  'applications.text.entityOperation': 'Operación',
  'applications.text.created': 'Fecha de Creación',
  'applications.text.executionOrder': 'Orden de Ejecución',
  'applications.text.affectedItems': 'Elementos Afectados',
  'applications.text.startedDateTime': 'Inicio Procesamiento',
  'applications.text.finishedDateTime': 'Fecha Finalizada',
  'applications.text.data': 'Datos',
  'applications.text.updated': 'Fecha Actualizada',
  'applications.text.processingAttempts': 'Intentos de Procesamiento',

  'application.text.iterationDynamicEntity': 'Entidad Dinámica: {name}',
  'application.text.iterationForm': 'Formulario: {name}',
  'application.text.iterationTable': 'Tabla: {name}',

  'applications.text.sendStatus': 'Estado Envío',
  'applications.text.sentData': 'Datos Enviados',
  'applications.text.responseStatus': 'Estado Respuesta',

  'applications.text.entity': 'Entidad',
  'applications.text.dynamicEntity.operation': 'Operación Entidad Dinámica',
  'applications.text.dynamicEntity.affected': 'Elementos Afectados',
  'applications.text.dynamicEntity.quantity': 'Cantidad de Elementos',
  'applications.text.dynamicEntity.filters': 'Filtros',
  'applications.text.dynamicEntity.tableFilters': 'Filtros / Tabla',
  'applications.text.dynamicEntity.response': 'Respuesta',

  'applications.text.documents': 'Documentos',
  'applications.text.documents.viewList': 'Vista de lista',
  'applications.text.documents.viewGrid': 'Vista de mosaico',
  'applications.text.generatedDocuments': 'Documentos Generados',
  'applications.text.loadingMore': 'Cargando configuraciones adicionales...',

  'applications.text.sendNotifications': 'La notificación ha sido reenviada.',
  'applications.text.approveNotification': 'La solicitud ha sido aprobada.',
  'applications.text.voidNotification': 'La solicitud ha sido rechazada.',
  'applications.text.cancelNotification': 'La solicitud ha sido cancelada.',

  'variablesInfo.internalName': 'Nombre Interno',
  'variablesInfo.type': 'Tipo',
  'variablesInfo.initialValue': 'Valor Inicial',

  'applications.text.bulkTask.detail': 'Detalles',
  'applications.text.bulkTask.all': 'Todos',
  'applications.text.bulkTask.pending': 'Lista - Pendiente',
  'applications.text.bulkTask.done': 'Lista - Ok',
  'applications.text.bulkTask.failure': 'Lista - Error',

  'applications.text.bulkTask.lineNumber': 'Número de Línea',
  'applications.text.bulkTask.bulkRequestNumber': 'Nro. Solicitud (Excel)',
  'applications.text.bulkTask.operation': '¿Operación Satisfactoria?',
  'applications.text.bulkTask.request': 'Solicitud',
  'applications.text.bulkTask.totalRequests': 'Total de Solicitudes',
  'applications.text.bulkTask.failureKind': 'Tipo de Fallo',
  'applications.text.bulkTask.failureKind.transient': 'Transitorio',
  'applications.text.bulkTask.failureKind.functional': 'Funcional',
  'applications.text.bulkTask.failureKind.invalidFile': 'Archivo Inválido',
  'applications.text.bulkTask.failureKind.corruptedFile': 'Archivo Corrupto',
  'applications.text.bulkTask.failureKind.resourceLimitExceeded': 'Límite de Recursos Excedido',
  'applications.text.bulkTask.failureKind.unexpected': 'Inesperado',
  'applications.text.bulkTask.retryDisposition': 'Disposición de Reintento',
  'applications.text.bulkTask.retryDisposition.retryable': 'Reintentable',
  'applications.text.bulkTask.retryDisposition.nonRetryable': 'No Reintentable',
  'applications.text.bulkTask.retryDisposition.manualReview': 'Revisión Manual',
  'applications.text.bulkTask.failureCode': 'Código de Fallo',

  'applications.text.bulkTaskType0': 'Pendiente',
  'applications.text.bulkTaskType1': 'Procesando',
  'applications.text.bulkTaskType2': 'Procesado',
  'applications.text.bulkTaskType3': 'Error',
  'applications.text.bulkTaskType4': 'Procesando Tareas',
  'applications.text.bulkTaskType5': 'Cancelado',

  'applications.text.dynamicEntityOperationType1': 'Buscar',
  'applications.text.dynamicEntityOperationType2': 'Adicionar',
  'applications.text.dynamicEntityOperationType3': 'Modificar',
  'applications.text.dynamicEntityOperationType4': 'Eliminar',
  'applications.text.dynamicEntityOperationType5': 'Contar',
  'applications.text.dynamicEntityOperationType6': 'Suma',
  'applications.text.dynamicEntityOperationType7': 'Resta',
  'applications.text.dynamicEntityOperationType8': 'Aumentar',
  'applications.text.dynamicEntityOperationType9': 'Disminuir',
  'applications.text.dynamicEntityOperationType10': 'Evaluar Fórmula',

  'application.text.whatsAppBusinessOperationType.send-message': 'Enviar Mensaje',

  'application.text.processTriggerIdentifier': 'Identificador del Mensaje',
  'application.text.processTriggerSender': 'Remitente',

  'applications.text.engineVersionType1': 'V1',
  'applications.text.engineVersionType2': 'V2',

  'applications.text.actionType0': 'Predeterminado',
  'applications.text.actionType1': 'Completar Información',
  'applications.text.actionType2': 'Aprobación',
  'applications.text.actionType3': 'Aprobación Automática',
  'applications.text.actionType4': 'Condicional',
  'applications.text.actionType5': 'Ejecutar Tarea',
  'applications.text.actionType6': 'Ejecutar Llamada API',
  'applications.text.actionType7': 'Rechazo Automático',
  'applications.text.actionType8': 'Firma Digital',
  'applications.text.actionType9': 'Enviar Correo',
  'applications.text.actionType10': 'Ejecutar Consulta de Base de Datos',
  'applications.text.actionType11': 'Operación sobre Entidad Dinámica',
  'applications.text.actionType12': 'Generar Excel',
  'applications.text.actionType13': 'Iniciar Proceso',
  'applications.text.actionType14': 'Establecer Variable',
  'applications.text.actionType15': 'Establecer Datos de Formulario',
  'applications.text.actionType16': 'Paralelo',
  'applications.text.actionType17': 'Generar Documentos',
  'applications.text.actionType18': 'Ejecución Programada',
  'applications.text.actionType19': 'Operación en SharePoint',
  'applications.text.actionType20': 'Iterar / Aplicar a cada uno',
  'applications.text.actionType21': 'Switch',
  'applications.text.actionType22': 'Operación Interna',
  'applications.text.actionType23': 'Generar Fichero Texto',
  'applications.text.actionType24': 'Importar Archivo de Texto sin Formato',
  'applications.text.actionType25': 'Consumir Secuencia',
  'applications.text.actionType26': 'Ejecutar Flujo RPA',
  'applications.text.actionType27': 'Integración',
  'applications.text.actionType28': 'Cancelar Automático',
  'applications.text.actionType29': 'Anular Automático',
  'applications.text.actionType30': 'Open AI',
  'applications.text.actionType31': 'Ejecutar Acción Proceso',
  'applications.text.actionType32': 'Integración Google',
  'applications.text.actionType33': 'Revertir Cancelación',
  'applications.text.actionType34': 'Revertir Anulación',
  'applications.text.actionType35': 'Operación FTP',
  'applications.text.actionType36': 'Ejecutar Código',
  'applications.text.actionType37': 'Automy IA',
  'applications.text.actionType38': 'Integración WhatsApp Business',
  'applications.text.actionType39': 'Integración Microsoft Teams',
  'applications.text.actionType40': 'Esperar Solicitudes Hijas',
  'applications.text.actionType41': 'Enviar SMS',

  'applications.text.logicalOperatorType0': 'OR',
  'applications.text.logicalOperatorType1': 'AND',

  'applications.text.myRequests': 'Mis Solicitudes',
  'applications.text.receivedRequests': 'Recibidas',
  'applications.text.revisionRequests': 'Revisión',
  'applications.text.allRequests': 'Todas',
  'applications.text.bulkRequests': 'Carga Masiva',

  'applications.text.cancellationReason': 'Motivo de Cancelación',
  'applications.text.rejectedReason': 'Motivo del Rechazo',
  'applications.text.voidedReason': 'Motivo de Anulación',

  'applications.text.requestType0': 'Solicitud en Evaluación',
  'applications.text.requestType1': 'Solicitud Aprobada',
  'applications.text.requestType2': 'Solicitud Rechazada',
  'applications.text.requestType3': 'Solicitud Cancelada',
  'applications.text.requestType4': 'Solicitud Anulada',
  'applications.text.requestType5': 'Solicitud con Error',

  'applications.text.actionType.0': 'Iniciado Por',
  'applications.text.actionType.1': 'Formulario',
  'applications.text.actionType.3': 'Acción aprobada automáticamente por el sistema',
  'applications.text.actionType.4': 'Resultado de Aprobación',
  'applications.text.actionType.7': 'Acción rechazada automáticamente por el sistema',
  'applications.text.actionType.6': 'Conexión API',
  'applications.text.actionType.10': 'Conexión Base de Datos',
  'applications.text.actionType.11': 'Entidad Dinámica',
  'applications.text.actionType.13': 'Proceso',
  'applications.text.actionType.18': 'Fecha y Hora de Ejecución Programada',
  'applications.text.actionType.19': 'Configuración SharePoint',
  'applications.text.actionType.20': 'Origen de Datos a Recorrer',
  'applications.text.actionType.22': 'Operación Interna',
  'applications.text.actionType.23': 'Formato',
  'applications.text.actionType.24': 'Formato',
  'applications.text.actionType.25': 'Secuencia',
  'applications.text.actionType.26': 'Agente RPA',
  'applications.text.actionType.27': 'Integración',
  'applications.text.actionType.28': 'Auto Cancelar',
  'applications.text.actionType.29': 'Auto Anular',
  'applications.text.actionType.30': 'Open AI',
  'applications.text.actionType.31': 'Ejecutar Acción',
  'applications.text.actionType.32': 'Integración Google',
  'applications.text.actionType.33': 'Revertir Cancelar',
  'applications.text.actionType.34': 'Revertir Anular',
  'applications.text.actionType.35': 'Operación FTP',
  'applications.text.actionType.36': 'Ejecutar Código',
  'applications.text.actionType.37': 'Controlador',

  'applications.text.valueSourceType1': 'Formulario / Campo',
  'applications.text.valueSourceType2': 'Variable',
  'applications.text.valueSourceType3': 'Iteración Paso Actual',

  'applications.text.originValue': 'Valor Fijo',
  'applications.text.destinationForm': 'Formulario Destino',
  'applications.text.destinationField': 'Campo Destino',
  'applications.text.value': 'Valor',
  'applications.text.lineNumber': 'Número de Línea',
  'applications.text.tableFieldName': 'Campo Tabla',
  'applications.text.lineId': 'Id de Línea',
  'applications.text.field': 'Campo',
  'applications.text.variable': 'Variable',
  'applications.text.operator': 'Operador',
  'applications.text.conditionValue': 'Valor Condición',
  'applications.text.evaluationValue': 'Valor de Evaluación',
  'applications.text.evaluationObservations': 'Resultado',
  'applications.text.valueSource': 'Origen Valor',

  'applications.text.actionInstanceStatus.3': 'Fecha y Hora de Vencimiento',
  'applications.text.execution': 'Ejecución',

  'applications.text.responseError': 'Mensaje de Error',
  'applications.text.responseStatusCode': 'Código de Respuesta',
  'applications.text.responseData': 'Datos de Respuesta',
  'applications.text.requestPayload': 'Datos Enviados',
  'applications.text.requestUrl': 'URL de Solicitud',
  'applications.text.httpMethod': 'Método HTTP',

  'applications.text.sequencePattern': 'Patrón Secuencia',
  'applications.text.sequenceItemPattern': 'Patrón Item Secuencia',
  'applications.text.generatedNumber': 'Número Generado',
  'applications.text.sequenceItemId': 'Identificador Sub Secuencia',
  'applications.text.sequenceTraceId': 'Identificador Traza Secuencia',

  'applications.text.requestMethod0': '? ',
  'applications.text.requestMethod1': 'POST',
  'applications.text.requestMethod2': 'GET',
  'applications.text.requestMethod3': 'PUT',
  'applications.text.requestMethod4': 'DELETE',

  'applications.text.variableType1': 'Texto',
  'applications.text.variableType2': 'Número',
  'applications.text.variableType3': 'Fecha y Hora',
  'applications.text.variableType4': 'Fecha',
  'applications.text.variableType5': 'Hora',
  'applications.text.variableType6': 'Matriz',
  'applications.text.variableType7': 'Documento',

  'applications.text.startModeType1': 'Flujo Manual',
  'applications.text.startModeType2': 'Flujo Automatizado',
  'applications.text.startModeType3': 'Flujo Programado',

  'applications.text.document.type': 'Tipo',
  'applications.text.document.user': 'Propietario',
  'applications.text.document.filename': 'Nombre',
  'applications.text.document.created': 'Ult. Modificación',
  'applications.text.document.size': 'Tamaño Archivo',
  'applications.text.document.contentType': 'Tipo de Contenido',
  'applications.text.document.form': 'Formulario',
  'applications.text.document.field': 'Campo',
  'applications.text.document.actionName': 'Acción',

  'applications.text.Attachment': 'Adjunto',
  'applications.text.Generated': 'Generado',
  'applications.text.VariableAttachment': 'Adjunto Variable',
  'applications.text.TableAttachment': 'Adjunto Tabla',
  'applications.text.CommentAttachment': 'Adjunto Comentario',

  'applications.text.email.detail': 'Detalles Trazas Correo',
  'applications.text.mail.event': 'Evento',
  'applications.text.mail.date': 'Fecha',
  'applications.text.mail.smtpId': 'SmtpId',

  'applications.text.email.id': 'Id',
  'applications.text.email.messageType': 'Tipo',
  'applications.text.email.email': 'Correo',
  'applications.text.email.eventDate': 'Fecha Evento',
  'applications.text.email.smtpId': 'SmtpId',
  'applications.text.email.eventId': 'EventId',
  'applications.text.email.messageId': 'MessageId',
  'applications.text.email.mailEventDescription': 'Evento',
  'applications.text.email.mailEventLongDescription': 'Descripción',
  'applications.text.email.created': 'Fecha de Creación',
  'applications.text.email.reason': 'Motivo',
  'applications.text.email.userAgent': 'Agente de Usuario',
  'applications.text.email.ip': 'IP',
  'applications.text.email.environment': 'Entorno',

  'applications.text.operationType.search': 'Buscar',
  'applications.text.operationType.add': 'Adicionar',
  'applications.text.operationType.modify': 'Modificar',
  'applications.text.operationType.delete': 'Eliminar',
  'applications.text.operationType.remove': 'Eliminar',
  'applications.text.operationType.count': 'Contar',
  'applications.text.operationType.sum': 'Suma',
  'applications.text.operationType.subtract': 'Resta',
  'applications.text.operationType.increase': 'Aumentar',
  'applications.text.operationType.decrement': 'Disminuir',
  'applications.text.operationType.evaluate-formula': 'Evaluar Fórmula',

  'applications.text.dynamicEntityOperationType.search': 'Búsqueda',
  'applications.text.dynamicEntityOperationType.add': 'Adicionar',
  'applications.text.dynamicEntityOperationType.modify': 'Modificar',
  'applications.text.dynamicEntityOperationType.remove': 'Eliminar',
  'applications.text.dynamicEntityOperationType.count': 'Contar',
  'applications.text.dynamicEntityOperationType.sum': 'Sumar',
  'applications.text.dynamicEntityOperationType.subtraction': 'Restar',
  'applications.text.dynamicEntityOperationType.increment': 'Incrementar',
  'applications.text.dynamicEntityOperationType.decrement': 'Decrementar',
  'applications.text.dynamicEntityOperationType.evaluateformula': 'Evaluar Fórmula',
  'applications.text.dynamicEntityOperationType.evaluate-formula': 'Evaluar Fórmula',
  'applications.text.internalOperationType.search': 'Buscar',
  'applications.text.internalOperationType.add': 'Adicionar',
  'applications.text.internalOperationType.modify': 'Modificar',
  'applications.text.internalOperationType.activate': 'Activar',
  'applications.text.internalOperationType.deactivate': 'Desactivar',
  'applications.text.internalOperationType.remove': 'Eliminar',
  'applications.text.internalOperationType.count': 'Contar',
  'applications.text.internalOperationType.cancel-delegation': 'Anular Delegación',

  'application.text.sharePointOperationType1': 'Cargar Fichero',
  'application.text.sharePointOperationType.upload-file': 'Cargar Fichero',
  'application.text.sharePointOperationType.download-file': 'Descargar Fichero',

  'applications.text.iterationDataSourceType1': 'Tabla de Formulario',
  'applications.text.iterationDataSourceType2': 'Entidad Dinámica',
  'applications.text.iterationDataSourceType3': 'Campo Adjunto de Formulario',
  'applications.text.iterationDataSourceType.form-table': 'Tabla Formulario',
  'applications.text.iterationDataSourceType.dynamic-entity': 'Entidad Dinámica',
  'applications.text.iterationDataSourceType.form-field-attachment': 'Campo Adjunto de Formulario',

  'applications.text.internalOperationEntityType.user': 'Usuario',
  'applications.text.internalOperationEntityType.position': 'Cargo',
  'applications.text.internalOperationEntityType.area': 'Área',
  'applications.text.internalOperationEntityType.user-group': 'Grupo de Usuarios',
  'applications.text.internalOperationEntityType.user-group-user': 'Grupo de Usuarios Usuario',
  'applications.text.internalOperationEntityType.environment': 'Entorno',
  'applications.text.internalOperationEntityType.chat-thread-participant': `Participante de Conversación`,
  'applications.text.internalOperationEntityType.ai-agent-vector':
    'Agente IA / Vector de Entrenamiento',
  'applications.text.internalOperationEntityType.environment-user': 'Entorno Usuario',
  'applications.text.internalOperationEntityType.delegation': 'Delegación',
  'applications.text.internalOperationEntityType.delegation-configuration':
    'Configuración de Delegación',
  'applications.text.internalOperationEntityType.global-entity-approver-by-areas':
    'Entidad Global Autorizada por Áreas',
  'applications.text.internalOperationEntityType.global-entity-approver-by-positions':
    'Entidad Global Autorizada por Cargos',
  'applications.text.internalOperationEntityType.global-entity-approver-by-user-groups':
    'Aprobador Global de Entidades por Grupos de Usuarios',
  'applications.text.internalOperationEntityType.global-entity-approver-by-users':
    'Aprobador Global de Entidades por Usuarios',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-areas':
    'Aprobador Global de Grupos de Usuarios por Áreas',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-positions':
    'Aprobador Global de Grupos de Usuarios por Puestos',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-users':
    'Usuarios del Grupo Global de Usuarios Aprobadores',
  'applications.text.internalOperationEntityType.report-trace': 'Seguimiento de Informes',
  'applications.text.internalOperationEntityType.internal-task': 'Tarea Interna',
  'applications.text.internalOperationEntityType.process-instance': 'Instancia del Proceso',

  'applications.text.internalOperationEntityType1': 'Usuario',
  'applications.text.internalOperationEntityType2': 'Cargo',
  'applications.text.internalOperationEntityType3': 'Área',
  'applications.text.internalOperationEntityType4': 'Grupo de Usuarios',
  'applications.text.internalOperationEntityType5': 'Grupo de Usuarios Usuario',
  'applications.text.internalOperationEntityType6': 'Entorno',
  'applications.text.internalOperationEntityType7': 'Entorno Usuario',
  'applications.text.internalOperationEntityType8': 'Delegación',
  'applications.text.internalOperationEntityType9': 'Configuración de Delegación',
  'applications.text.internalOperationEntityType10': 'Entidad Global Autorizada por Áreas',
  'applications.text.internalOperationEntityType11': 'Entidad Global Autorizada por Cargos',
  'applications.text.internalOperationEntityType12':
    'Aprobador Global de Entidades por Grupos de Usuarios',
  'applications.text.internalOperationEntityType13': 'Aprobador Global de Entidades por Usuarios',
  'applications.text.internalOperationEntityType14':
    'Aprobador Global de Grupos de Usuarios por Áreas',
  'applications.text.internalOperationEntityType15':
    'Aprobador Global de Grupos de Usuarios por Puestos',
  'applications.text.internalOperationEntityType16':
    'Usuarios del Grupo Global de Usuarios Aprobadores',
  'applications.text.internalOperationEntityType17': 'Seguimiento de informes',
  'applications.text.internalOperationEntityType18': 'Tarea Interna',
  'applications.text.internalOperationEntityType19': 'Instancia del Proceso',
  'applications.text.internalOperationEntityType20': 'Participante de Conversación',
  'applications.text.internalOperationEntityType21': 'Agente IA / Vector de Entrenamiento',

  'applications.text.processInstanceFormFieldAttachment': 'Adjunto',
  'applications.text.processInstanceGeneratedDocument': 'Documento Generado',
  'applications.text.processInstanceVariableAttachment': 'Adjunto',
  'applications.text.processInstanceCommentAttachment': 'Adjunto',
  'applications.text.entityAttachment': 'Adjunto',
  'applications.text.processInstanceApiCallAttachment': 'Adjunto',
  'applications.text.listExportGeneratedFile': 'Archivo Generado',
  'applications.text.dynamicEntityExportGeneratedFile': 'Archivo Generado',
  'applications.text.dynamicEntityImportGeneratedErrorFile': 'Archivo de Error Generado',
  'applications.text.processInstanceOpenAICallAttachment': 'Adjunto',
  'applications.text.processInstanceAutomyAIAttachment': 'Adjunto',
  'applications.text.processInstanceRunCodeAttachment': 'Adjunto',
  'applications.text.chatThreadAttachment': 'Adjunto',
  'applications.text.configurationEntityExportGeneratedFile': 'Archivo Generado',
  'applications.text.configurationEntityImportGeneratedErrorFile': 'Archivo de Error Generado',
  'applications.text.manualUpload': 'Subida Manual',

  'applications.text.actionInstanceStatus0': 'Pendiente',
  'applications.text.actionInstanceStatus1': 'Enviado',
  'applications.text.actionInstanceStatus2': 'Error',

  'applications.text.action.instanceStatus0': 'Pendiente',
  'applications.text.action.instanceStatus1': 'Finalizada',
  'applications.text.action.instanceStatus2': 'Rechazada',
  'applications.text.action.instanceStatus3': 'Vencido',
  'applications.text.action.instanceStatus4': 'Omitido',
  'applications.text.action.instanceStatus5': 'Error',
  'applications.text.action.instanceStatus6': 'Ejecutada',

  'applications.text.comparisonOperatorType1': 'Igual',
  'applications.text.comparisonOperatorType2': 'Diferente',
  'applications.text.comparisonOperatorType3': 'Mayor Que',
  'applications.text.comparisonOperatorType4': 'Mayor Que o Igual',
  'applications.text.comparisonOperatorType5': 'Menor Que',
  'applications.text.comparisonOperatorType6': 'Menor Que o Igual',
  'applications.text.comparisonOperatorType7': 'Contiene',
  'applications.text.comparisonOperatorType8': 'No Contiene',
  'applications.text.comparisonOperatorType9': 'Es Nulo',
  'applications.text.comparisonOperatorType10': 'No es Nulo',

  'applications.text.plainTextFileFormat.json': 'JSON',
  'applications.text.plainTextFileFormat.text': 'TXT',
  'applications.text.plainTextFileFormat.csv': 'CSV',
  'applications.text.plainTextFileFormat.xml': 'XML',
  'applications.text.plainTextFileFormat.parquet': 'PARQUET',

  'applications.text.statusDate': 'Fecha',
  'applications.text.statusReason': 'Motivo del Rechazo',
  'applications.text.statusUser': 'Usuario',

  'applications.text.message.success': 'La solicitud {name} fue {action} satisfactoriamente',
  'applications.text.message.error': 'La solicitud {name} no pudo ser {action}',
  'applications.text.message.processInstanceStatusChange':
    'El estado de la solicitud ha cambiado, en breve será redirigido a la vista detalles.',

  'applications.text.message.commandType1': 'aprobada',
  'applications.text.message.commandType2': 'rechazada',
  'applications.text.message.commandType3': 'completada',
  'applications.text.message.commandType4': 'ejecutada',
  'applications.text.message.commandType5': 'firmada',
  'applications.text.message.commandType6': 'cancelada',
  'applications.text.message.commandType7': 'anulada',
  'applications.text.message.commandType8': 'enviada',
  'applications.text.message.commandType9': 'evaluada',
  'applications.text.message.commandType10': 'retrocedida',
  'applications.text.message.commandType11': 're-asignada',
  'applications.text.message.commandType12': 'ejecutada',
  'applications.text.message.commandType15': 'asignada',
  'applications.text.message.commandType28': 'cancelada',
  'applications.text.message.commandType29': 'anulada',

  'applications.text.googleIntegrationOperationType1': 'Cargar Archivo',
  'applications.text.googleIntegrationOperationType2': 'Descargar Archivo',

  'application.text.googleOperationType.download-file': 'Descargar Archivo',
  'application.text.googleOperationType.upload-file': 'Cargar Archivo',
  'application.text.googleServiceType.google-drive': 'Google Drive',

  'application.text.fptOperationType.download-file': 'Descargar Archivo',
  'application.text.fptOperationType.upload-file': 'Cargar Archivo',

  'applications.text.openAIOperationType.parser': 'Analizador Sintáctico',
  'applications.text.openAIOperationType.generic': 'Genérico',

  'applications.text.automyAIHandlerType.agent': 'Agente',
  'applications.text.automyAIHandlerType.completions': 'Completions',
  'applications.text.automyAIHandlerType.responses': 'Respuestas',

  // Semantic per-action-type label keys
  'applications.text.executeApiCall.connectionName': 'Conexión API',
  'applications.text.runCode.connectionName': 'Conexión',
  'applications.text.runCode.programmingLanguage': 'Lenguaje',
  'applications.text.executeQuery.connectionName': 'Conexión Base de Datos',
  'applications.text.executeQuery.databaseName': 'Nombre Base de Datos',
  'applications.text.executeQuery.databaseQuery': 'Consulta base de Datos',
  'applications.text.dynamicEntityOperation.entityName': 'Entidad Dinámica',
  'applications.text.dynamicEntityOperation.operationType': 'Operación',
  'applications.text.startProcessInstance.processName': 'Proceso',
  'applications.text.openAI.connectionName': 'Conexión API',
  'applications.text.openAI.operationType': 'Operación',
  'applications.text.openAI.model': 'Modelo',
  'applications.text.automyAI.handlerType': 'Controlador',
  'applications.text.automyAI.agentName': 'Agente',
  'applications.text.automyAI.model': 'Modelo',
  'applications.text.googleIntegration.connectionName': 'Conexión',
  'applications.text.googleIntegration.serviceType': 'Servicio',
  'applications.text.googleIntegration.operationType': 'Operación',
  'applications.text.ftpOperation.connectionName': 'Conexión',
  'applications.text.ftpOperation.operationType': 'Operación',
  'applications.text.executeProcessAction.actionName': 'Acción',
  'applications.text.executeProcessAction.processName': 'Proceso',
  'applications.text.scheduledExecution.startDate': 'Fecha y Hora de Ejecución Programada',
  'applications.text.scheduledExecution.finishedDate': 'Fecha Finalizada',
  'applications.text.generateDocuments.finishedDateTime': 'Fecha Finalizada',
  'applications.text.sharePointOperation.connectionName': 'Configuración SharePoint',
  'applications.text.sharePointOperation.operationType': 'Operación',
  'applications.text.internalOperation.operationType': 'Tipo de Operación',
  'applications.text.internalOperation.entityType': 'Entidad',
  'applications.text.generatePlainTextFile.fileFormat': 'Formato',
  'applications.text.generatePlainTextFile.sourceForm': 'Formulario de Origen',
  'applications.text.generatePlainTextFile.sourceField': 'Campo de Origen',
  'applications.text.importPlainTextFile.fileFormat': 'Formato',
  'applications.text.importPlainTextFile.sourceForm': 'Formulario de Origen',
  'applications.text.importPlainTextFile.sourceField': 'Campo de Origen',
  'applications.text.consumeSequence.sequenceName': 'Secuencia',
  'applications.text.consumeSequence.pattern': 'Patrón',
  'applications.text.executeRpaFlow.agentName': 'Agente RPA',
  'applications.text.executeRpaFlow.flowName': 'Flujo RPA',
  'applications.text.integration.integrationName': 'Integración',
  'applications.text.integration.functionName': 'Función',
  'applications.text.whatsAppBusinessIntegration.connectionName': 'Conexión',
  'applications.text.whatsAppBusinessIntegration.operationType': 'Tipo de Operación',
  'applications.text.microsoftTeamsIntegration.connectionName': 'Conexión',
  'applications.text.waitForChildRequests.overdueDate': 'Fecha y Hora de Vencimiento',
  'applications.text.waitForChildRequests.results': 'Resultado esperar solicitudes hijas',
  'applications.text.waitChildRequests.tab.children': 'Solicitudes Hijas',
  'applications.text.waitChildRequests.summary.resultType': 'Tipo de resultado',
  'applications.text.waitChildRequests.summary.scope': 'Ámbito',
  'applications.text.waitChildRequests.summary.startActionId': 'ID acción inicio',
  'applications.text.waitChildRequests.summary.startActionName': 'Nombre acción inicio',
  'applications.text.waitChildRequests.summary.completionMode': 'Modo de finalización',
  'applications.text.waitChildRequests.summary.targetActionId': 'ID acción objetivo',
  'applications.text.waitChildRequests.summary.targetActionName': 'Nombre acción objetivo',
  'applications.text.waitChildRequests.summary.maxWaitTimeUnit': 'Unidad tiempo máx. espera',
  'applications.text.waitChildRequests.summary.maxWaitTimeValue': 'Valor tiempo máx. espera',
  'applications.text.waitChildRequests.summary.timeoutBehavior': 'Comportamiento al tiempo agotado',
  'applications.text.waitChildRequests.summary.timeoutDate': 'Fecha límite',
  'applications.text.waitChildRequests.summary.noChildrenBehavior': 'Comportamiento sin hijas',
  'applications.text.waitChildRequests.summary.childrenFailureBehavior':
    'Comportamiento ante fallos de hijas',
  'applications.text.waitChildRequests.summary.totalChildrenCount': 'Total hijas',
  'applications.text.waitChildRequests.summary.pendingChildrenCount': 'Hijas pendientes',
  'applications.text.waitChildRequests.summary.succeededChildrenCount': 'Hijas exitosas',
  'applications.text.waitChildRequests.summary.failedChildrenCount': 'Hijas fallidas',
  'applications.text.waitChildRequests.summary.lastEvaluationDateTime': 'Última evaluación',
  'applications.text.waitChildRequests.summary.completedDateTime': 'Fecha completado',
  'applications.text.waitChildRequests.items.childRequest': 'Solicitud hija',
  'applications.text.waitChildRequests.items.status': 'Estado',
  'applications.text.waitChildRequests.items.childProcessInstanceStatus': 'Estado solicitud hija',
  'applications.text.waitChildRequests.items.targetActionInstanceStatus': 'Estado acción objetivo',
  'applications.text.waitChildRequests.items.failureReason': 'Motivo fallo',
  'applications.text.waitChildRequests.items.observations': 'Observaciones',
  'applications.text.waitChildRequests.items.lastEvaluationDateTime': 'Última evaluación',
  'applications.text.waitChildRequests.items.completedDateTime': 'Fecha completado',
  'applications.text.waitChildRequestsItemStatus.pending': 'Pendiente',
  'applications.text.waitChildRequestsItemStatus.success': 'Exitoso',
  'applications.text.waitChildRequestsItemStatus.failed': 'Fallido',
  'applications.text.processInstanceStatus.execution': 'Ejecución',
  'applications.text.processInstanceStatus.approved': 'Aprobada',
  'applications.text.processInstanceStatus.rejected': 'Rechazada',
  'applications.text.processInstanceStatus.canceled': 'Cancelada',
  'applications.text.processInstanceStatus.voided': 'Anulada',
  'applications.text.processInstanceStatus.error': 'Error',
  'applications.text.waitChildRequestsItemFailureReason.none': 'Ninguno',
  'applications.text.waitChildRequestsItemFailureReason.childrejected': 'Solicitud hija rechazada',
  'applications.text.waitChildRequestsItemFailureReason.childcanceled': 'Solicitud hija cancelada',
  'applications.text.waitChildRequestsItemFailureReason.childvoided': 'Solicitud hija anulada',
  'applications.text.waitChildRequestsItemFailureReason.childerror': 'Error en solicitud hija',
  'applications.text.waitChildRequestsItemFailureReason.childfinishedwithouttargetaction':
    'Hija finalizó sin acción objetivo',
  'applications.text.waitChildRequestsItemFailureReason.targetactionerror':
    'Error en acción objetivo',
  'applications.text.waitChildRequestsItemFailureReason.targetactionnotsuccessful':
    'Acción objetivo no exitosa',
  'applications.text.waitChildRequestsResultType.none': 'Ninguno',
  'applications.text.waitChildRequestsResultType.nochildren': 'Sin hijas',
  'applications.text.waitChildRequestsResultType.allsucceeded': 'Todas exitosas',
  'applications.text.waitChildRequestsResultType.somefailed': 'Algunas fallidas',
  'applications.text.waitChildRequestsResultType.allfailed': 'Todas fallidas',
  'applications.text.waitChildRequestsResultType.timedout': 'Tiempo agotado',
  'applications.text.waitChildRequestsScope.allcurrentchildren': 'Todas las hijas actuales',
  'applications.text.waitChildRequestsScope.childrenstartedbyspecificaction':
    'Hijas iniciadas por acción específica',
  'applications.text.waitChildRequestsCompletionMode.untilchildrenfinish':
    'Hasta que finalicen las hijas',
  'applications.text.waitChildRequestsCompletionMode.untilchildrencompletespecificaction':
    'Hasta que completen acción específica',
  'applications.text.waitChildRequestsTimeoutBehavior.continue': 'Continuar',
  'applications.text.waitChildRequestsTimeoutBehavior.throwerror': 'Lanzar error',
  'applications.text.waitChildRequestsNoChildrenBehavior.continue': 'Continuar',
  'applications.text.waitChildRequestsNoChildrenBehavior.throwerror': 'Lanzar error',
  'applications.text.waitChildRequestsChildrenFailureBehavior.continuealways': 'Continuar siempre',
  'applications.text.waitChildRequestsChildrenFailureBehavior.throwerrorifanyfailed':
    'Error si alguna falla',
  'applications.text.waitChildRequestsChildrenFailureBehavior.throwerrorifallfailed':
    'Error si todas fallan',
  'applications.text.frequencyUnit.none': 'Ninguno',
  'applications.text.frequencyUnit.minute': 'Minuto',
  'applications.text.frequencyUnit.hour': 'Hora',
  'applications.text.frequencyUnit.day': 'Día',
  'applications.text.frequencyUnit.month': 'Mes',
  'applications.text.frequencyUnit.businessday': 'Día hábil',

  'applications.text.automyAIHandlerType.1': 'Completions',
  'applications.text.automyAIHandlerType.2': 'Agente',
  'applications.text.automyAIHandlerType.3': 'Respuestas',

  'applications.text.resourceType1': 'Usuario',
  'applications.text.resourceType2': 'Usuario Externo',
  'applications.text.resourceType3': 'Webhook',
  'applications.text.resourceType4': 'Instancia de Proceso Acción Iniciar Proceso',
  'applications.text.resourceType5': 'Disparador',
  'applications.text.resourceType6': 'Proceso Programado',
  'applications.text.resourceType7': 'Tarea Masiva',
  'applications.text.id': 'Identificador',
  'applications.text.actionInstanceId': 'Identificador de Instancia de Acción',

  'applications.text.operationResultStatus.pending': 'Pendiente',
  'applications.text.operationResultStatus.executing': 'Ejecutando',
  'applications.text.operationResultStatus.success': 'Exitoso',
  'applications.text.operationResultStatus.error': 'Error',
  'applications.text.operationResultStatus.failed': 'Fallido',

  'applications.text.automyAIHandlerType.completions': 'Finalizaciones',
  'applications.text.automyAIHandlerType.agent': 'Agente',
  'applications.text.automyAIHandlerType.responses': 'Respuestas',

  'application.message.backgroundData': 'El formulario está cargando datos en segundo plano.',
};
